export const categories = [
  {
    slug: "remen",
    name: "热门推荐",
    description: "全网热搜视频合集，每日实时更新",
    icon: "ri-fire-line",
    color: "bg-amber-500",
  },
  {
    slug: "dianying",
    name: "电影",
    description: "国内外高分大片，院线新片速递",
    icon: "ri-film-line",
    color: "bg-orange-500",
  },
  {
    slug: "dianshiju",
    name: "电视剧",
    description: "热门剧集每日更新，追剧首选",
    icon: "ri-tv-line",
    color: "bg-red-500",
  },
  {
    slug: "zongyi",
    name: "综艺",
    description: "爆笑综艺不间断，精彩不停歇",
    icon: "ri-emotion-happy-line",
    color: "bg-green-500",
  },
  {
    slug: "dongman",
    name: "动漫",
    description: "日漫国漫全覆盖，热血与治愈并存",
    icon: "ri-ghost-line",
    color: "bg-purple-500",
  },
  {
    slug: "jilupian",
    name: "纪录片",
    description: "探索世界奥秘，记录真实故事",
    icon: "ri-earth-line",
    color: "bg-teal-500",
  },
];